import { Component } from '@angular/core';
import { faArrowUpFromBracket, faCircleDown, faDownload, faEye, faPrint } from '@fortawesome/free-solid-svg-icons';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import * as print from 'print-js';
import { ModalCarteirinhaComponent } from 'src/app/shared/modals/modal-carteirinha/modal-carteirinha.component';
import { PersonService } from 'src/app/shared/services/person.service';
import { environment } from 'src/environments/environment';
import { CartaoService } from '../../../services/saude/cartao.service';
import { HealthService } from '../../../services/saude/health.service';
@Component({
  selector: 'app-cartao-digital',
  templateUrl: './cartao-digital.component.html',
  styleUrls: ['./cartao-digital.component.css']
})
export class CartaoDigitalComponent {
  faEye = faEye;
  faArrowUpFromBracket = faArrowUpFromBracket;
  faCircleDown = faCircleDown;
  faDownload = faDownload;
  faPrint = faPrint;
  cartoes!: any[];
  helper: any;
  testeCarteirinhas: any;
  loadingCosts: boolean = true;
  errorCosts: boolean = false;
  todosSelecionados: boolean = false;
  constructor(private personService: PersonService, private healthService: HealthService, private modalService: NgbModal,
    private cartaoService: CartaoService, private toast: ToastrService) {
    this.loadingCosts = true;
    this.personService.getPerson().subscribe((res: any) => {
      this.healthService.getCartoesDigital(res.cpf).subscribe((result: any) => {
        result.forEach(
          (element: any) => {
            element.link = environment.portalApi + element.link.split('api')[1];
          });
        this.cartoes = result;
        this.helper = environment.portalApi + result[0].link.split('api')[1];
        this.loadingCosts = false;
      });

    });
  }
  selecionarTodasCarteirinhas() {
    //Verifica se o botão já foi clicado uma vez, se sim ele transforma todos em false
    if (this.todosSelecionados == true) {
      document.querySelectorAll("input[type=checkbox]").forEach(
        (e: any) => {
          e['checked'] = false;
        }
      );
    }
    //Percorrer todos os elementos voltados pelo querySelector e transorma todos os estado checked em true
    if (this.todosSelecionados == false) {
      document.querySelectorAll("input[type=checkbox]").forEach(
        (e: any) => {
          e['checked'] = true;
        }
      );
    }
    this.todosSelecionados = !this.todosSelecionados;
  }
  imprimirCarteirinhas(): void {
    var carteirinhasSelecionadas = '';
    document.getElementsByName('carteirinhas').forEach(
      (x: any) => {
        if (x.checked) {
          carteirinhasSelecionadas += "cpf=" + x.value + "&";
        }
      });
    if (carteirinhasSelecionadas === "") {
      this.toast.error("Selecionar uma carteirinha!");
    } else {
      this.cartaoService.getCarteirinhas(carteirinhasSelecionadas.substring(0, carteirinhasSelecionadas.length - 1)).subscribe(
        (data: Blob) => {
          const a = document.createElement('a');
          a.setAttribute('style', 'display:none;');
          document.body.appendChild(a);
          a.download = "Carteirinhas.pdf";
          a.href = URL.createObjectURL(data);
          a.target = '_blank';
          a.click();
          document.body.removeChild(a);
        }
      )
    }
  }
  downloadCarteirinha(link: any): void {
    this.cartaoService.getCarteirinha(link).subscribe(
      (data: Blob) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          const base64data = reader.result as string;
  
          // Se estiver rodando em WebView Android, chama a interface nativa
          if ((window as any).AndroidDownload) {
            (window as any).AndroidDownload.downloadBase64File(base64data, "Carteirinha.png");
            this.toast.success('Arquivo Carteirinha.png baixado com sucesso!', 'Sucesso');
          } else {
            // Fallback para navegador normal
            const a = document.createElement('a');
            a.setAttribute('style', 'display:none;');
            document.body.appendChild(a);
            a.download = "Carteirinha.png";
            a.href = URL.createObjectURL(data);
            a.target = '_blank';
            a.click();
            document.body.removeChild(a);
            this.toast.success('Arquivo Carteirinha.png baixado com sucesso!', 'Sucesso');
          }
        };
        reader.readAsDataURL(data); // Converte para Base64
      }
    );
  }
  
  
  open(link: any): void {
    const modalRef = this.modalService.open(ModalCarteirinhaComponent, { windowClass: 'carteirinha-modal-size', centered: true });
    modalRef.componentInstance.url = link;
  }
  //Função para imprimir as carteirinhas
  prints(link: any) {
    this.cartaoService.getCarteirinha(link).subscribe(
      (data) => {
        const reader = new FileReader();
        reader.addEventListener('load', () => {
          print({
            printable: reader.result,
            type: 'image',
            imageStyle: 'width:95%; height:90%;'
          });
        }, false);
        if (data) {
          reader.readAsDataURL(data);
        }
      }
    )
  }
}
